import React from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Alert,
} from '@mui/material';
import { Construction } from '@mui/icons-material';

// 将来の実装用（現在はコメントアウト）
/*
import { useState } from 'react';
import {
  Card,
  CardContent,
  TextField,
  Slider,
} from '@mui/material';

interface SimulationParams {
  currentReserve: number;
  monthlyContribution: number;
  maintenanceYear: number;
  maintenanceCost: number;
  annualIncrease: number;
}
*/

const Simulation: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        積立金シミュレーション
      </Typography>

      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '60vh',
        textAlign: 'center'
      }}>
        <Paper sx={{ p: 6, maxWidth: 600, width: '100%' }}>
          <Construction 
            sx={{ 
              fontSize: 100, 
              color: 'primary.main', 
              mb: 3 
            }} 
          />
          
          <Typography variant="h5" gutterBottom color="primary">
            シミュレーション機能
          </Typography>
          
          <Typography variant="h6" gutterBottom>
            今後実装予定
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            積立金の将来推移や大規模修繕に向けた<br />
            財務計画シミュレーション機能を<br />
            今後のバージョンで提供予定です。
          </Typography>
          
          <Alert severity="info" sx={{ textAlign: 'left' }}>
            <Typography variant="body2">
              <strong>予定機能:</strong><br />
              • 積立金残高推移の予測<br />
              • 大規模修繕費用シミュレーション<br />
              • 複数シナリオの比較分析<br />
              • 修繕計画とリスク評価
            </Typography>
          </Alert>
        </Paper>
      </Box>
    </Container>
  );
};

/*
// 将来の実装用（現在はコメントアウト）
const SimulationDraft: React.FC = () => {
  const [params, setParams] = useState<SimulationParams>({
    currentReserve: 15720000,
    monthlyContribution: 350000,
    maintenanceYear: 5,
    maintenanceCost: 12000000,
    annualIncrease: 2,
  });

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
    }).format(amount);
  };

  const handleParamChange = (field: keyof SimulationParams, value: number) => {
    setParams(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        積立金シミュレーション
      </Typography>

      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        // ... 既存の実装コード（省略）
      </Box>
    </Container>
  );
};
*/

export default Simulation;